export default function universalTableStockIdExtractor(props) {
  const row = props?.resultMetaData;

  if (row?.stock_id !== null && typeof row?.stock_id !== "undefined") {
    return row.stock_id;
  }

  return null;
}
